import { render } from "./EditDonorDeclarationForm.vue?vue&type=template&id=49826888&scoped=true"
import script from "./EditDonorDeclarationForm.vue?vue&type=script&lang=js"
export * from "./EditDonorDeclarationForm.vue?vue&type=script&lang=js"

import "./EditDonorDeclarationForm.vue?vue&type=style&index=0&id=49826888&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49826888"]])

export default __exports__